import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog/dialog";
import { ROUTES } from "../../routes";
import { CreateNC } from "./create-nc";

export function CreateNCDialog() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleOpenChange = useCallback(
    (open: boolean) =>
      void (!open && setTimeout(() => navigate(ROUTES.HOME), 500)),
    [navigate]
  );

  const handleSuccess = useCallback(
    (id?: string) => {
      if (!id) return navigate(ROUTES.HOME);

      navigate(ROUTES.SENTENCE_NC(id));
    },
    [navigate]
  );

  const handleCancel = useCallback(() => {
    navigate(ROUTES.HOME);
  }, [navigate]);

  return (
    <Dialog defaultOpen onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-7xl h-[880px] [@media(max-height:880px)]:h-full">
        <DialogHeader>
          <DialogTitle>{t("nc.title")}</DialogTitle>
        </DialogHeader>

        <CreateNC onSuccess={handleSuccess} onCancel={handleCancel} />
      </DialogContent>
    </Dialog>
  );
}
